import { render, staticRenderFns } from "./ListaContratos.vue?vue&type=template&id=3a814aee"
import script from "./ListaContratos.vue?vue&type=script&lang=js"
export * from "./ListaContratos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports